import { useRouter } from "@tanstack/react-router";
import type { Client, FamilyDetail } from "creso-core/types";
import { PortfolioValuationDialog } from "web-core";

type PortfolioValuationProps =
  | { client: Client; family?: never }
  | { family: FamilyDetail; client?: never };

/**
 * Partners adapter for the shared portfolio valuation dialog: maps the
 * `modal=portfolio-valuation` search param driven open/close and the
 * import-holdings navigation onto the controlled web-core component.
 */
export function PortfolioValuation(props: PortfolioValuationProps) {
  const router = useRouter();

  const onOpenChange = (open: boolean) => {
    if (!open) router.history.back();
  };

  const onImportHoldings = () =>
    router.navigate({
      to: ".",
      search: (prev) => ({ ...prev, modal: "import-holdings" }),
    });

  if (props.family) {
    return (
      <PortfolioValuationDialog
        family={props.family}
        open
        onOpenChange={onOpenChange}
      />
    );
  }

  return (
    <PortfolioValuationDialog
      client={props.client}
      open
      onOpenChange={onOpenChange}
      onImportHoldings={onImportHoldings}
    />
  );
}
